import React, { useState, useEffect } from "react";
import axios from "axios";
import SubjectsInputs from "../components/SubjectsInputs";
import { useSelector, useDispatch } from "react-redux";
import {
  getAllClasses,
  setSections,
  setTheoreticalSubjects,
  setGradingSubjects,
  getStudentById,
  updateStudents,
  setCurrentStudentData
} from "../features/studentSlice";
import { useSearchParams, useNavigate } from "react-router-dom";
import CoScholastic from "../components/CoScholastic";
import { TiArrowBack } from "react-icons/ti";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddStudentForm = ({ handleState }) => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const studentID = searchParams.get("id");

  const [reportData, setReportData] = useState({
    scholar_name: "",
    father_name: "",
    mother_name: "",
    dob: "",
    contact_number: "",
    class: "",
    section: "",
    s_r_no: "",
    class_teacher_remark: "",
    promoted_to_class: ""
  });
  const classesData = useSelector((state) => state.student.classes);
  const sectionData = useSelector((state) => state.student.sections);
  
  const currentStudentData = useSelector(
    (state) => state.student.current_student_data
  );

  useEffect(() => {
    if (!studentID) return;
    dispatch(getStudentById(studentID));
  }, [studentID]);

  const theoreticalSubjects = useSelector(
    (state) => state.student.theoritical_subjects
  );
  const gradingSubjects = useSelector(
    (state) => state.student.grading_subjects
  );



  // Per Test Data
  const [perTestTerm1, setPerTestTerm1] = useState("");
  const [perTestTerm2, setPerTestTerm2] = useState("");
  // Note Book Data
  const [notebookTerm1, setNotebookTerm1] = useState("");
  const [notebookTerm2, setNotebookTerm2] = useState("");
  // Sub Enrichement
  const [subEnrichmentTerm1, setSubEnrichmentTerm1] = useState("");
  const [subEnrichmentTerm2, setSubEnrichmentTerm2] = useState("");
  // half Yearly
  const [halfYearlyTerm1, setHalfYearlyTerm1] = useState("");
  const [halfYearlyTerm2, setHalfYearlyTerm2] = useState("");

  const [coScholasticTerm1, setCoScholasticTerm1] = useState({
    work_education: "",
    art_education: "",
    health_education: "",
    discipline: "",
  });
  const [coScholasticTerm2, setCoScholasticTerm2] = useState({
    work_education: "",
    art_education: "",
    health_education: "",
    discipline: "",
  });

  const createHandleState = (setState) => (name, values) => {
    setState((prev) => ({ ...prev, [name]: values }));
  };

  const handlePerTestTerm1State = createHandleState(setPerTestTerm1);
  const handlePerTestTerm2State = createHandleState(setPerTestTerm2);
  const handleNoteBookTerm1State = createHandleState(setNotebookTerm1);
  const handleNoteBookTerm2State = createHandleState(setNotebookTerm2);
  const handleSubEnrichmentTerm1State = createHandleState(
    setSubEnrichmentTerm1
  );
  const handleSubEnrichmentTerm2State = createHandleState(
    setSubEnrichmentTerm2
  );
  const handleHalfYearlyTerm1State = createHandleState(setHalfYearlyTerm1);
  const handleHalfYearlyTerm2State = createHandleState(setHalfYearlyTerm2);
  const handleCoScholasticTerm1 = createHandleState(setCoScholasticTerm1);
  const handleCoScholasticTerm2 = createHandleState(setCoScholasticTerm2);

  const handleChange = () => {
    if (!theoreticalSubjects || !gradingSubjects) return;
    const theoreticalObj = theoreticalSubjects.reduce((acc, curr) => {
      acc[curr] = null;
      return acc;
    }, {});

    const gradingObj = gradingSubjects.reduce((acc, curr) => {
      acc[curr] = null;
      return acc;
    }, {});

    if(!studentID) return;
    setPerTestTerm1(
      currentStudentData?.pre_test?.term1 || {
        ...theoreticalObj,
        ...gradingObj,
      }
    );
    setPerTestTerm2(
      currentStudentData?.pre_test?.term2 || {
        ...theoreticalObj,
        ...gradingObj,
      }
    );
    setNotebookTerm1(
      currentStudentData?.note_book?.term1 || {
        ...theoreticalObj,
        ...gradingObj,
      }
    );
    setNotebookTerm2(
      currentStudentData?.note_book?.term2 || {
        ...theoreticalObj,
        ...gradingObj,
      }
    );
    setSubEnrichmentTerm1(
      currentStudentData?.sub_enrichement?.term1 || {
        ...theoreticalObj,
        ...gradingObj,
      }
    );
    setSubEnrichmentTerm2(
      currentStudentData?.sub_enrichement?.term2 || {
        ...theoreticalObj,
        ...gradingObj,
      }
    );
    setHalfYearlyTerm1(
      currentStudentData?.half_yearly?.term1 || {
        ...theoreticalObj,
        ...gradingObj,
      }
    );
    setHalfYearlyTerm2(
      currentStudentData?.half_yearly?.term2 || {
        ...theoreticalObj,
        ...gradingObj,
      }
    );
  };


  useEffect(() => {
    handleChange();
  }, [theoreticalSubjects, gradingSubjects]);

  useEffect(() => {
    if (!currentStudentData || !studentID) return;
    const Class =
      classesData &&
      classesData.find((c) => c.name === currentStudentData.class);
    dispatch(setTheoreticalSubjects(Class?.theoretical_subjects));
    dispatch(setGradingSubjects(Class?.grading_subjects));

    setReportData({
      scholar_name: currentStudentData?.scholar_name || "",
      father_name: currentStudentData?.father_name || "",
      mother_name: currentStudentData?.mother_name || "",
      dob: currentStudentData?.dob || "",
      contact_number: currentStudentData?.contact_number || "",
      class: currentStudentData?.class || "",
      section: currentStudentData?.section || "",
      s_r_no: currentStudentData?.s_r_no || "",
      class_teacher_remark: currentStudentData?.class_teacher_remark || "",
      promoted_to_class: currentStudentData?.promoted_to_class || ""
    });
    setCoScholasticTerm1(currentStudentData?.co_scholastic?.term1);
    setCoScholasticTerm2(currentStudentData?.co_scholastic?.term2);
    // setNotebookTerm1(currentStudentData?.note_book?.term1);
  }, [currentStudentData]);

  // Classes and Sections
  useEffect(() => {
    dispatch(getAllClasses());
  }, []);

  const ClassSelection = (classname) => {
    const Class = classesData.find((c) => c.name === classname);
    dispatch(setSections(Class.section));
    dispatch(setTheoreticalSubjects(Class.theoretical_subjects));
    dispatch(setGradingSubjects(Class.grading_subjects));
  };

  const classesList =
    classesData &&
    classesData.map((el, index) => {
      return (
        <option key={index} value={el.name}>
          {el.name}
        </option>
      );
    });

  const sectionList =
    sectionData &&
    sectionData.map((el, index) => {
      return (
        <option key={index} value={el}>
          {el}
        </option>
      );
    });

  const handleReportData = (name, value) => {
    setReportData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      ...reportData,
      pre_test: {
        term1: perTestTerm1,
        term2: perTestTerm2,
      },
      note_book: {
        term1: notebookTerm1,
        term2: notebookTerm2,
      },
      sub_enrichement: {
        term1: subEnrichmentTerm1,
        term2: subEnrichmentTerm2,
      },
      half_yearly: {
        term1: halfYearlyTerm1,
        term2: halfYearlyTerm2,
      },
      co_scholastic: {
        term1: coScholasticTerm1,
        term2: coScholasticTerm2,
      },
    };

    dispatch(updateStudents(formData, studentID));
    const notify = () => toast("Student Data Submitted Successfully!");
    notify();
  };

  return (
    <div className="max-w-6xl mx-auto mt-10 p-6 rounded-lg shadow-md border-2 border-gray-100  w-full">
      <h1 className="text-3xl font-bold mb-6 text-center">Student Report</h1>
      <div className="flex justify-end items-end">
        <button
          onClick={() => {
            setCurrentStudentData(null)
            navigate("/dashboard")
            }}
          className="bg-gray-800 text-white font-semibold py-2 px-6 rounded-lg flex justify-center items-center gap-2 mb-4 "
        >
          {" "}
          <TiArrowBack className="text-xl" /> <span>Back to Dashboard</span>
        </button>
      </div>

      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <form onSubmit={(e) => handleSubmit(e)}>
        <h2 className="text-xl font-bold uppercase text-gray-700 mb-2">
          Basic Details
        </h2>
        <div className="mb-4 flex justify-between space-x-6">
          {/* Scholar Name */}

          <div className="w-full">
            <label className="block text-sm font-bold mb-2">
              Scholar Name:
            </label>
            <input
              type="text"
              name="scholar_name"
              value={reportData.scholar_name}
              onChange={(e) => handleReportData("scholar_name", e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md outline-none"
              required
            />
          </div>
          {/* S. R. No. */}
          <div className="w-full ">
            <label className="block text-sm font-bold mb-2">S. R. No.</label>
            <input
              type="number"
              name="s_r_no"
              value={reportData.s_r_no}
              onChange={(e) => {
                const inputValue = e.target.value;
                const regex = /^[0-9]*$/;
                if (regex.test(inputValue)) {
                  handleReportData("s_r_no", inputValue);
              }}}
              className="w-full p-2 border border-gray-300 rounded-md outline-none"
              required
            />
          </div>
        </div>
        {/* Father Name and Mother Name */}
        <div className="mb-4 flex justify-between space-x-6">
          {/* Father Name */}
          <div className="w-full">
            <label className="block text-sm font-bold mb-2">Father Name:</label>
            <input
              type="text"
              name="father_name"
              value={reportData.father_name}
              onChange={(e) => handleReportData("father_name", e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md outline-none"
            />
          </div>
          {/* Mother Name */}
          <div className="w-full">
            <label className="block text-sm font-bold mb-2">Mother Name:</label>
            <input
              type="text"
              name="mother_name"
              value={reportData.mother_name}
              onChange={(e) => handleReportData("mother_name", e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md outline-none"
              required
            />
          </div>
        </div>
        {/* D.O.B and Contact Number */}
        <div className="mb-4 flex justify-between space-x-6">
          {/* D.O.B */}
          <div className="w-full">
            <label className="block text-sm font-bold mb-2">D.O.B:</label>
            <input
              type="date"
              name="dob"
              value={reportData.dob}
              onChange={(e) => handleReportData("dob", e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md outline-none"
            />
          </div>
          {/* Contact Number */}
          <div className="w-full">
            <label className="block text-sm font-bold mb-2">
              Contact Number:
            </label>
            <input
              type="tel"
              name="contact_number"
              value={reportData.contact_number}
              onChange={(e) => {
                const inputValue = e.target.value;
                const regex = /^[0-9]*$/;
                if (regex.test(inputValue)) {
                  handleReportData("contact_number", inputValue);
              }}}
              className="w-full p-2 border border-gray-300 rounded-md outline-none"
              required
            />
          </div>
        </div>
        <div className="w-full my-4">
          <label className="block text-sm font-bold mb-2">
            Class Teacher Remark:
          </label>
          <input
            type="text"
            name="class_teacher_remark"
            value={reportData.class_teacher_remark}
            onChange={(e) =>
              handleReportData("class_teacher_remark", e.target.value)
            }
            className="w-full p-2 border border-gray-300 rounded-md outline-none"
          />
        </div>
        {/* Class and Section */}
        <div className="mb-4 flex justify-between space-x-6">
          <div className="w-full">
            <label className="block text-sm font-bold mb-2">Class:</label>
            <select
              name="class"
              value={reportData.class}
              onChange={(e) => {
                handleReportData("class", e.target.value);
                ClassSelection(e.target.value);
              }}
              className="p-3 text-gray-800 text-sm font-medium rounded-md bg-gray-100 w-full"
            >
              <option value="">Select Class</option>
              {classesList}
            </select>
          </div>
          <div className="w-full">
            <label className="block text-sm font-bold mb-2">Section:</label>
            <select
              name="section"
              value={reportData.section}
              onChange={(e) => handleReportData("section", e.target.value)}
              className="p-3 text-gray-800 text-sm font-medium rounded-md bg-gray-100 w-full"
            >
              <option value="">Select Section</option>
              {sectionList}
            </select>
          </div>
        </div>

        <div className="mt-4">
          <h2 className="text-xl font-bold uppercase text-gray-700 mb-2">
            Per Test
          </h2>
          <div className="mb-4 px-3 py-1 rounded-md w-full bg-gray-200">
            <p className="font-semibold">Term 1</p>
          </div>
          <SubjectsInputs
            formdata={perTestTerm1}
            handleStateChange={handlePerTestTerm1State}
          />

          <div className="mb-4 px-3 py-1 rounded-md w-full bg-gray-200">
            <p className="font-semibold">Term 2</p>
          </div>
          <SubjectsInputs
            formdata={perTestTerm2}
            handleStateChange={handlePerTestTerm2State}
          />
        </div>

        <div className="mt-4">
          <h2 className="text-xl font-bold uppercase text-gray-700 mb-2">
            Note Book
          </h2>
          <div className="mb-4 px-3 py-1 rounded-md w-full bg-gray-200">
            <p className="font-semibold">Term 1</p>
          </div>
          <SubjectsInputs
            formdata={notebookTerm1}
            handleStateChange={handleNoteBookTerm1State}
          />
          <div className="mb-4 px-3 py-1 rounded-md w-full bg-gray-200">
            <p className="font-semibold">Term 2</p>
          </div>
          <SubjectsInputs
            formdata={notebookTerm2}
            handleStateChange={handleNoteBookTerm2State}
          />
        </div>

        <div className="mt-4">
          <h2 className="text-xl font-bold uppercase text-gray-700 mb-2">
            Sub Enrichement
          </h2>
          <div className="mb-4 px-3 py-1 rounded-md w-full bg-gray-200">
            <p className="font-semibold">Term 1</p>
          </div>
          <SubjectsInputs
            formdata={subEnrichmentTerm1}
            handleStateChange={handleSubEnrichmentTerm1State}
          />

          <div className="mb-4 px-3 py-1 rounded-md w-full bg-gray-200">
            <p className="font-semibold">Term 2</p>
          </div>
          <SubjectsInputs
            formdata={subEnrichmentTerm2}
            handleStateChange={handleSubEnrichmentTerm2State}
          />
        </div>

        <div className="mt-4">
          <h2 className="text-xl font-bold uppercase text-gray-700 mb-2">
            Half Yearly
          </h2>
          <div className="mb-4 px-3 py-1 rounded-md w-full bg-gray-200">
            <p className="font-semibold">Term 1</p>
          </div>
          <SubjectsInputs
            formdata={halfYearlyTerm1}
            handleStateChange={handleHalfYearlyTerm1State}
          />

          <div className="mb-4 px-3 py-1 rounded-md w-full bg-gray-200">
            <p className="font-semibold">Term 2</p>
          </div>
          <SubjectsInputs
            formdata={halfYearlyTerm2}
            handleStateChange={handleHalfYearlyTerm2State}
          />
        </div>

        {/* CO-SCHOLASTIC AREAS */}
        <div className="mt-6">
          <h2 className="text-xl font-bold text-gray-700 mb-2">
            CO-SCHOLASTIC AREAS
          </h2>
          <div className="mb-4 px-3 py-1 rounded-md w-full bg-gray-200">
            <p className="font-semibold">Term 1</p>
          </div>
          <CoScholastic
            data={coScholasticTerm1}
            handleCoScholasticData={handleCoScholasticTerm1}
          />
        </div>

        <div className="mt-8">
          <h2 className="text-xl font-bold text-gray-700 mb-2">
            CO-SCHOLASTIC AREAS
          </h2>
          <div className="mb-4 px-3 py-1 rounded-md w-full bg-gray-200">
            <p className="font-semibold">Term 2</p>
          </div>
          <CoScholastic
            data={coScholasticTerm2}
            handleCoScholasticData={handleCoScholasticTerm2}
          />
        </div>

         <div className="w-full mb-4 mt-8">
          <label className="block text-sm font-bold mb-0">
            Promoted To Class:
          </label>
          <input
            type="text"
            name="promoted_to_class"
            value={reportData.promoted_to_class}
            onChange={(e) =>
              handleReportData("promoted_to_class", e.target.value)
            }
            placeholder="Enter Which Class Student Will Be Promoted!"
            className="w-full p-2 border border-gray-300 rounded-md outline-none"
          />
        </div>

        {/* Submit Button */}
        <div className="mb-4 mt-6 flex justify-start">
          <button
            // onClick={(e) => handleSubmit(e)}
            type="submit"
            className="max-w-4xl bg-orange-600 font-semibold text-white py-2 px-12  rounded-md transition duration-300 ease-in-out hover:bg-orange-700"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddStudentForm;
